// import { RouterProvider } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from './store/store';
import { setAuthToken } from './api';
import { ToastContainer } from 'react-toastify';
import Custombutton from './components/custombutton/custombutton';
// import { Router } from './Router';
import 'react-toastify/dist/ReactToastify.css';
import MfaPinModal from './components/MfaPinModal';
import { ConfigProvider } from 'antd';
import { BaseRoutes } from './routes/BaseRoutes';

function App() {
    const state = useSelector((state: RootState) => ({
        token: state.user.token,
        user: state.user.user
    }));

    const { token } = state;
    setAuthToken(token);

    return (
        <ConfigProvider
            theme={{
                token: {
                    fontSize: 13,
                    colorPrimary: '#0088b2',
                    colorInfo: '#0088b2',
                    colorError: '#f04438',
                    colorSuccess: '#12b76a',
                    colorWarning: '#f79009',
                    colorTextBase: '#101828',
                    borderRadiusXS: 8,
                    borderRadiusLG: 8,
                    borderRadius: 8
                },
                components: {
                    Alert: {
                        defaultPadding: '8px',
                        colorSuccessText: '#12B76A'
                    },
                    Select: {
                        borderRadius: 4
                    },
                    Badge: {
                        dotSize: 8
                    },
                    Table: {
                        headerBg: 'rgb(249, 250, 251)'
                    },
                    Checkbox: {
                        colorPrimaryBorder: 'rgb(0, 136, 178)',
                        colorWhite: 'rgb(0, 136, 178)',
                        colorPrimary: '#E5F3F7',
                        borderRadiusSM: 4,
                        colorPrimaryHover: '#E5F3F7',
                        colorPrimaryBgHover: '#E5F3F7',
                        colorPrimaryBorderHover: 'rgb(0, 136, 178)',
                        colorPrimaryActive: '',
                        colorBorder: 'rgb(208, 213, 221)',
                        colorBorderSecondary: 'rgb(0, 136, 178)',
                        controlInteractiveSize: 16
                    }
                }
            }}
        >
            <div className='relative App'>
                <ToastContainer toastClassName='toast-z-index' />

                <MfaPinModal />

                {false && (
                    <div className='bg-appcolorprimary pt-[0.6rem] justify-center flex items-center pb-[0.8rem] fixed w-full z-10'>
                        <p className='mr-[1.9rem] text-appcolorwhite text-[15px] leading-[19px] tracking-[0.01rem]'>
                            Ready to start using FrontEdge? Set up in minutes
                        </p>
                        <Custombutton
                            buttonText='Continue Setup'
                            styles={{
                                padding: '0.5rem',
                                fontSize: '15px',
                                lineHeight: '19px',
                                letterSpacing: '0.01rem',
                                color: '#0088B2',
                                backgroundColor: '#ffffff',
                                '&:hover': {
                                    backgroundColor: '#ffffff'
                                }
                            }}
                        />
                        <p className='absolute text-appcolorwhite top-[0.7rem] right-[1.6rem]'>
                            <span className='cursor-pointer'>x</span>
                        </p>
                    </div>
                )}

                {/* <RouterProvider router={Router} /> */}
                <BaseRoutes />
            </div>
        </ConfigProvider>
    );
}

export default App;
